import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as AppActions from '../../../AppActions';

function Landing(props) {
  const {landing} = props;

  // seasonbakery custom
  return (
    <Wrapper>
      <div className="content">
        <div style={{height: 60}} />

        <img
          src="/images/landing-main.jpg"
          alt="landing-main"
          className="main-image"
        />

        <div className="description">Unexpected and unintentional beauty</div>
        <div className="description">Simple moments we desire</div>
        <div className="description">And moments will be eternity</div>
        <div className="description">
          Not complicated but takes love in heart
        </div>
        <div className="description">To enjoy the moment of serendipity</div>

        <button
          className="shop-now"
          onClick={() => {
            AppActions.navigate('products');
          }}>
          <img src="/images/shop-now.png" alt="shop-now" />
        </button>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);

  background-image: url('/images/landing-background.jpg');
  background-size: cover;
  background-position: center center;
  /* background-attachment: fixed; */
  background-repeat: no-repeat;
  min-height: 100vh;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #dfdfdf;
    font-family: 'kepler-3-display-variable', sans-serif;

    & > .description {
      text-align: center;
      margin-bottom: 4px;
    }
  }

  .main-image {
    width: 360px;
    max-width: 100vw;
    margin: 0 auto 20px;
  }

  button.shop-now {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-top: 20px;
    margin-bottom: 40px;

    & > img {
      width: 160px;
    }
    transition: background-color 0.2s;
    &:hover {
      background-color: #25447e;
      & > img {
        filter: grayscale(100%);
      }
    }
  }
`;

export default Landing;
